// Обёртка над Telegram WebApp. Всё, что зависит от того, открыто ли приложение
// внутри Telegram, спрятано здесь: в браузере (стенд, отладка) продукт должен
// продолжать работать, а не падать на отсутствующем window.Telegram.

interface TelegramWebApp {
  initData: string
  colorScheme: string
  themeParams: Record<string, string>
  ready(): void
  expand(): void
  disableVerticalSwipes?(): void
  setHeaderColor?(color: string): void
  setBackgroundColor?(color: string): void
  HapticFeedback?: {
    impactOccurred(style: 'light' | 'medium' | 'heavy'): void
    selectionChanged(): void
    notificationOccurred(type: 'error' | 'success' | 'warning'): void
  }
  BackButton?: {
    show(): void
    hide(): void
    onClick(handler: () => void): void
    offClick(handler: () => void): void
  }
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp }
  }
}

export const webApp = (): TelegramWebApp | undefined => window.Telegram?.WebApp

/**
 * initData для подписи запросов. В браузере вне Telegram берём его из адреса
 * (#tgWebAppData=… — так же, как это делает сам Telegram), чтобы можно было
 * зайти на стенд обычным хромом.
 */
export function initData(): string {
  const fromApp = webApp()?.initData
  if (fromApp) return fromApp
  const hash = window.location.hash.replace(/^#/, '')
  const params = new URLSearchParams(hash)
  return params.get('tgWebAppData') ?? ''
}

export function setupTelegram(): void {
  const app = webApp()
  if (!app) return
  app.ready()
  app.expand()
  app.disableVerticalSwipes?.()
  app.setHeaderColor?.('#0B0C11')
  app.setBackgroundColor?.('#0B0C11')
}

export function haptic(style: 'light' | 'medium' | 'heavy' = 'light'): void {
  webApp()?.HapticFeedback?.impactOccurred(style)
}

/**
 * Системная кнопка «назад». Возвращает функцию-отписку: экран, который её
 * показал, обязан её же и убрать, иначе стрелка останется на главной.
 */
export function showBackButton(handler: () => void): () => void {
  const button = webApp()?.BackButton
  if (!button) return () => undefined
  button.onClick(handler)
  button.show()
  return () => {
    button.offClick(handler)
    button.hide()
  }
}
